import { ArrowNarrowLeftIcon } from "@heroicons/react/solid";
import { useState, useEffect, Fragment, useRef } from "react";
import Layout from "../../components/Layout/Layout";
import CustomerServices from "../../services/CustomerServices";
import {
  FormatMoney,
  FormatMoneyWithoutCurrency,
} from "./../../utils/formatMoney";
import { Dialog, Transition } from "@headlessui/react";
import { HollowDotsSpinner } from "react-epic-spinners";
import fire from "./../../utils/Toastr";
import * as HiIcons from "react-icons/hi";

const statusStyles = {
  true: "bg-green-500 text-white",
  false: "bg-orange-600 text-white",
  Active: "bg-green-500 text-white",
  Inactive: "bg-orange-600 text-white",
  Enabled: "bg-orange-600 text-white",
};
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function CustomerSettngs({ id: idProp, userId: userIdProp }) {
  const searchParams = new URLSearchParams(window.location.search);
  const id = idProp || searchParams.get("id");
  const customerUserId = userIdProp || searchParams.get("userId") || null;
  const cancelButtonRef = useRef(null);
  const errors = {
    lockAmountError: "",
    lockAmountIsValidated: false,
    limitAmountError: "",
    limitAmountIsValidated: false,
    formSubmitted: false,
  };
  const [open, setOpen] = useState(false);
  const [reject, setReject] = useState(false);
  const [loading, setLoading] = useState({ loading: false });
  const [rejectLoading, setRejectLoading] = useState({ loading: false });
  const [set, getSet] = useState({});
  const [formValue, setFormValues] = useState({
    limitAmount: 0,
    lockAmount: true,
  });
  const [exceptionFormValue, setExceptionFormValue] = useState({
    dailyIndividualLimit: 0,
    dailyCorporateLimit: 0,
    individualLimitPerTransaction: 0,
    corporateLimitPerTransaction: 0,
    concessionDocumentLink: [],
  });
  const [formState, setFormState] = useState(errors);
  const [adminType, setAdminType] = useState("");
  const [user, setUser] = useState("");
  const [openException, setOpenException] = useState(false);
  const [userId, setUserId] = useState(0);
  const [concessionRejectionReason, setConcessionRejectionReason] =
    useState("");
  const [commentError, setCommentError] = useState("");
  const [openDefault, setOpenDefault] = useState(false);
  const [rejectDefault, setRejectDefault] = useState(false);
  const [customerDefaultLimitStatus, setCustomerDefaultLimitStatus] =
    useState("Initiated");

  const settt = async () => {
    try {
      const resp = await CustomerServices.listSettings(id);
      getSet(resp.data);
      const userDetail = sessionStorage.getItem("user");
      const userDetails = JSON.parse(userDetail);
      setAdminType(userDetails.adminType);
      const user = await CustomerServices.viewCustomer(
        customerUserId ? { userId: customerUserId } : id,
      );
      setUserId(user?.data?.userId ?? customerUserId ?? 0);
    } catch (err) {
      fire("error", "Failed to load customer details");
    }
  };

  const showModal = (user) => {
    setOpen(true);
    setUser(user.userName);
    setFormValues({
      limitAmount: FormatMoneyWithoutCurrency(user.limitAmount),
    });
  };

  const showDefaultLimit = () => {
    setOpenDefault(true);
    setUser(user.userName);
  };

  const rejectDefaultLimit = () => {
    setRejectDefault(true);
  };

  const setDefaultLimit = async () => {
    setLoading({ loading: true });

    const status =
      adminType.toLowerCase() === "maker" ? "Initiated" : "Approved";

    const payload = {
      userId: userId,
      customerDefaultLimitStatus: status,
    };

    const res = await CustomerServices.setDefaultLimit(payload);
    if (res) {
      fire("success", res.message);
      setTimeout(() => {
        setOpenDefault(false);
        window.location.reload();
      }, 2000);
    }
  };

  const declineDefaultLimit = async () => {
    setLoading({ loading: true });

    const payload = {
      userId: userId,
      customerDefaultLimitStatus: "Rejected",
    };

    const res = await CustomerServices.setDefaultLimit(payload);
    if (res) {
      fire("success", res.message);
      setTimeout(() => {
        setOpenDefault(false);
        window.location.reload();
      }, 2000);
    }
  };

  const formatStringToNumber = (formattedString) => {
    if (formattedString === null || formattedString === undefined || formattedString === '') return 0;
    return parseFloat(String(formattedString).replace(/,/g, ""));
  };

  const showException = () => {
    setOpenException(true);
    if (set.exceptionalLimitDetails != null || set.exceptionalLimitDetails) {
      const individualApprovalValue =
        set.exceptionalLimitDetails.dailyIndividualLimit;
      const corporateApprovalValue =
        set.exceptionalLimitDetails.dailyCorporateLimit;
      const individualLimitPerTransactionApprovalValue =
        set.exceptionalLimitDetails.individualLimitPerTransaction;
      const corporateLimitPerTransactionApprovalValue =
        set.exceptionalLimitDetails.corporateLimitPerTransaction;
      const concessionDocumentLink =
        set.exceptionalLimitDetails.concessionDocumentLink;

      setExceptionFormValue({
        ...exceptionFormValue,
        dailyIndividualLimit: individualApprovalValue || 0,
        dailyCorporateLimit: corporateApprovalValue || 0,
        individualLimitPerTransaction:
          individualLimitPerTransactionApprovalValue || 0,
        corporateLimitPerTransaction:
          corporateLimitPerTransactionApprovalValue || 0,
        concessionDocumentLink: concessionDocumentLink || [],
      });
      setOpenException(true);
    }
  };

  const exception = async () => {
    setLoading({ loading: true });

    // Convert formatted strings back to numbers
    const dailyIndividualLimit = formatStringToNumber(
      exceptionFormValue.dailyIndividualLimit
    );
    const dailyCorporateLimit = formatStringToNumber(
      exceptionFormValue.dailyCorporateLimit
    );
    const individualLimitPerTransaction = formatStringToNumber(
      exceptionFormValue.individualLimitPerTransaction
    );
    const corporateLimitPerTransaction = formatStringToNumber(
      exceptionFormValue.corporateLimitPerTransaction
    );

    const fileInput = document.getElementById("inputFile");
    const files =
      fileInput && fileInput.files && fileInput.files.length > 0
        ? fileInput.files[0]
        : null;

    if (adminType.toLowerCase() === "maker" && !files) {
      setLoading({ loading: false });
      alert("Upload concession Document to process");
      return;
    }

    if (adminType.toLowerCase() === "checker" && !concessionRejectionReason.trim()) {
      setLoading({ loading: false });
      setCommentError("Comment is required");
      return;
    }

    // Constructing the payload
    const payload = {
      userId: userId,
      dailyIndividualLimit,
      dailyCorporateLimit,
      individualLimitPerTransaction,
      corporateLimitPerTransaction,
      ConcessionDocument: files,
    };



    // Call the API function with the payload
    const res = await CustomerServices.exceptionalLimit(payload);

    // Handle the response
    if (res && res.status) {
      fire("success", res.message);
      setTimeout(() => {
        setOpen(false);
        window.location.reload();
      }, 5000);
    }

    setLoading({ loading: false });
  };

  const exceptionValidation = {
    handleFileInputChange: (event) => {
      const files = event.target.files;
      const newFiles = Array.from(files).map((file) => file.name);
      const updatedFiles = [
        ...(exceptionFormValue.concessionDocumentLink || []),
        ...newFiles,
      ];

      setExceptionFormValue({
        ...exceptionFormValue,
        concessionDocumentLink: updatedFiles,
      });
    },

    exceptionAmountHandler: (event) => {
      const { name, value } = event.target;
      let rawValue = value.replace(/[^\d.]/g, "");

      // Ensure only one decimal point
      const parts = rawValue.split(".");
      if (parts.length > 2) {
        rawValue = parts[0] + "." + parts.slice(1).join("");
      }

      // Limit to 2 decimal places if decimal exists
      if (parts.length > 1) {
        rawValue = parts[0] + "." + parts[1].slice(0, 2);
      }

      // Format with commas for thousands
      let formattedValue = "";
      if (rawValue) {
        const number = parseFloat(rawValue);
        if (!isNaN(number)) {
          formattedValue = number.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          });
        }
      }

      setExceptionFormValue({
        ...exceptionFormValue,
        [name]: formattedValue,
      });

      setFormState({
        ...formState,
        limitAmountError: "",
        limitAmountIsValidated: true,
      });
    },
  };

  const getName = (fileUrl) => {
    return fileUrl.split("/").pop();
  };

  // rejection integration
  const rejectException = async () => {
    if (!concessionRejectionReason.trim()) {
      setCommentError("Comment is required");
      return;
    }

    setRejectLoading({ loading: true });

    // Constructing the payload
    const payload = {
      userId: userId,
      concessionRejectionReason: concessionRejectionReason,
    };

    const res = await CustomerServices.rejectExceptionLimit(payload);
    if (res) {
      fire("success", res.message);
      setTimeout(() => {
        setOpen(false);
        window.location.reload();
      }, 5000);
    }
    setRejectLoading({ loading: false });

  };

  const handleCommentChange = (e) => {
    const { value } = e.target;
    setConcessionRejectionReason(value);
  };

  const validateComment = (e) => {
    if (!concessionRejectionReason.trim()) {
      setCommentError("Comment is required");
      return false;
    } else {
      setCommentError("");
      return true;
    }
  };

  const showReject = () => {
    setReject(true);
  };

  const approve = async () => {
    setLoading({ loading: true });
    // const isFilled = formState.limitAmountIsValidated;
    // if (adminType.toLowerCase() === "maker") {
    //     if (!isFilled) {
    //         fire("error", "Field is required");
    //         setLoading({ loading: false });
    //         return;
    //     }
    // }
    const isLocked =
      adminType.toLowerCase() === "maker" && formValue.lockAmount === undefined
        ? true
        : formValue.lockAmount;
    const amount =
      adminType.toLowerCase() === "checker"
        ? set.limitAmount
        : formValue.limitAmount;
    const payload = {
      limitAmount: amount,
      lockAmount: isLocked,
    };
    const resp = await CustomerServices.updateCustomerLimit(user, payload);
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        setOpen(false);
        window.location.reload();
      }, 5000);
    }
    setLoading({ loading: false });
  };

  const rejectLimit = async (name) => {
    setRejectLoading({ loading: true });
    const resp = await CustomerServices.rejectCustomerLimit(name);
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        setOpen(false);
        window.location.reload();
      }, 5000);
    }
    setLoading({ loading: false });
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleRejectClose = () => {
    setReject(false);
  };

  const handleExceptionClose = () => {
    setOpenException(false);
  };

  const handleDefaultClose = () => {
    setOpenDefault(false);
  };

  const validation = {
    amountHandler: (event) => {
      const { value } = event.target;
      let rawValue = value.replace(/[^\d.]/g, "");

      // Ensure only one decimal point
      const parts = rawValue.split(".");
      if (parts.length > 2) {
        rawValue = parts[0] + "." + parts.slice(1).join("");
      }

      // Limit to 2 decimal places if decimal exists
      if (parts.length > 1) {
        rawValue = parts[0] + "." + parts[1].slice(0, 2);
      }

      // Format with commas for thousands
      let formattedValue = "";
      if (rawValue) {
        const number = parseFloat(rawValue);
        if (!isNaN(number)) {
          formattedValue = number.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          });
        }
      }

      setFormValues({
        ...formValue,
        limitAmount: formattedValue,
      });

      setFormState({
        ...formState,
        limitAmountError: "",
        limitAmountIsValidated: true,
      });
    },
    lockHandler: (event) => {
      setFormValues({ ...formValue, lockAmount: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          lockAmountError: "Lock amount cannot be empty",
          lockAmountIsValidated: false,
        });
        return;
      }
      setFormState({
        ...formState,
        lockAmountError: "",
        lockAmountIsValidated: true,
      });
    },
  };

  useEffect(() => {
    settt();
  }, []);
  const content = (
    <main>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="py-4">
              {idProp ? null : (
                <>
                  <a
                    href={
                      customerUserId
                        ? `/customer/view?userId=${customerUserId}`
                        : `/customer/view?id=${id}`
                    }
                  >
                    <div className="flex">
                      <ArrowNarrowLeftIcon className="w-6 h-4 flex self-center" />
                      <p> Back</p>
                    </div>
                  </a>
                  <div className="flex justify-center mb-10">
                    <div>
                      <h4 className="font-bold">
                        {set.surname} {set.firstName}
                      </h4>
                    </div>
                  </div>
                </>
              )}
              <div className="px-4 sm:px-6 lg:px-8">
                <div className="mt-5 grid grid-cols-1  sm:gap-6 sm:grid-cols-2 lg:grid-cols-6">
                  <div className="col-span-2">
                    <p className="mb-4">App Settings</p>
                    <div className="flex justify-between mb-3">
                      <p className="text-xs ml-2">PremiumMobile App Settings</p>
                      <p className="text-xs mr-3">Status</p>
                    </div>
                    <div className="bg-white shadow overflow-hidden sm:rounded-md">
                      <div role="list" className="divide-y divide-gray-200">
                        <div className="block hover:bg-gray-50">
                          <div className="flex items-center  py-4 ">
                            <div className="min-w-0 flex-1 flex items-center">
                              <div className="min-w-0 flex-1 px-2 md:grid  md:gap-4">
                                <div className="hidden md:block">
                                  <div>
                                    <p className="text-sm text-gray-900">
                                      Biometric Transactions
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className={classNames(
                                statusStyles[set.biometricTransaction],
                                "mr-2.5 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900"
                              )}
                            >
                              {set.biometricTransaction === false
                                ? "OFF"
                                : "ON"}
                            </div>
                          </div>
                        </div>
                        <div className="block hover:bg-gray-50">
                          <div className="flex items-center  py-4 ">
                            <div className="min-w-0 flex-1 flex items-center">
                              <div className="min-w-0 flex-1 px-2 md:grid  md:gap-4">
                                <div className="hidden md:block">
                                  <div>
                                    <p className="text-sm text-gray-900">
                                      Biometric Login
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className={classNames(
                                statusStyles[set.biometricLogin],
                                "mr-2.5 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900"
                              )}
                            >
                              {set.biometricLogin === false ? "OFF" : "ON"}
                            </div>
                          </div>
                        </div>
                        <div className="block hover:bg-gray-50">
                          <div className="flex items-center  py-4 ">
                            <div className="min-w-0 flex-1 flex items-center">
                              <div className="min-w-0 flex-1 px-2 md:grid  md:gap-4">
                                <div className="hidden md:block">
                                  <div>
                                    <p className="text-sm text-gray-900">
                                      Mask Mode
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className={classNames(
                                statusStyles[set.stealthMode],
                                "mr-2.5 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900"
                              )}
                            >
                              {set.stealthMode !== "Active" ? "OFF" : "ON"}
                            </div>
                          </div>
                        </div>
                        <div className="block hover:bg-gray-50">
                          <div className="flex items-center  py-4 ">
                            <div className="min-w-0 flex-1 flex items-center">
                              <div className="min-w-0 flex-1 px-2 md:grid  md:gap-4">
                                <div className="hidden md:block">
                                  <div>
                                    <p className="text-sm text-gray-900">
                                      Sleep Mode
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className={classNames(
                                statusStyles[set.freezeTransactions],
                                "mr-2.5 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900"
                              )}
                            >
                              {set.freezeTransactions === false ? "OFF" : "ON"}
                            </div>
                          </div>
                        </div>
                        <div className="block hover:bg-gray-50">
                          <div className="flex items-center  py-4 ">
                            <div className="min-w-0 flex-1 flex items-center">
                              <div className="min-w-0 flex-1 px-2 md:grid  md:gap-4">
                                <div className="hidden md:block">
                                  <div>
                                    <p className="text-sm text-gray-900">
                                      Panic Mode
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className={classNames(
                                statusStyles[set.panicModeEnabled],
                                "mr-2.5 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900"
                              )}
                            >
                              {set.panicModeEnabled === false ? "OFF" : "ON"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Individual */}
                  <div className="col-span-4">
                    <p className="mb-4 font-bold text-[2xl]">
                      Transaction Limits
                    </p>
                    <p className="underline mb-3">Individual</p>
                    <div className="flex justify-between mb-3">
                      <p className="text-xs mr-4">Transaction Type</p>
                      <p className="text-xs ml-4">Daily Limit</p>
                      <p className="text-xs">Available Transaction Limit</p>
                      <p className="text-xs">Limit Per Transaction</p>
                    </div>
                    <div className="bg-white shadow overflow-hidden sm:rounded-md">
                      <div role="list" className="divide-y divide-gray-200">
                        <div>
                          <div className="block hover:bg-gray-50">
                            <div className="flex items-center px-4 py-4 sm:px-6">
                              <div className="min-w-0 flex-1 flex items-center">
                                <div className="min-w-0 flex-1  md:grid md:grid-cols-3 md:gap-4">
                                  <div>
                                    <p className="text-sm font-medium mt-2">
                                      Airtime
                                    </p>
                                  </div>
                                  <div className="hidden md:block">
                                    <div>
                                      <p className="mt-2 flex items-center text-sm text-gray-500">
                                        {FormatMoney(set.dailyAirtimeLimit)}
                                      </p>
                                    </div>
                                  </div>
                                  <div>
                                    <p className="text-sm font-medium mt-2">
                                      {FormatMoney(set.availableAirtimeLimit)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <p className="text-sm font-medium mt-2">
                                  {FormatMoney(set.dailyAirtimeLimit)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="block hover:bg-gray-50">
                            <div className="flex items-center px-4 py-4 sm:px-6">
                              <div className="min-w-0 flex-1 flex items-center">
                                <div className="min-w-0 flex-1  md:grid md:grid-cols-3 md:gap-4">
                                  <div>
                                    <p className="text-sm font-medium mt-2">
                                      Bill Payment
                                    </p>
                                  </div>
                                  <div className="hidden md:block">
                                    <div>
                                      <p className="mt-2 flex items-center text-sm text-gray-500">
                                        {FormatMoney(set.dailyBillLimit)}
                                      </p>
                                    </div>
                                  </div>
                                  <div>
                                    <p className="text-sm font-medium mt-2">
                                      {FormatMoney(set.availableBillLimit)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <p className="text-sm font-medium mt-2">
                                  {FormatMoney(set.dailyBillLimit)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="block hover:bg-gray-50">
                            <div className="flex items-center px-4 py-4 sm:px-6">
                              <div className="min-w-0 flex-1 flex items-center">
                                <div className="min-w-0 flex-1  md:grid md:grid-cols-3 md:gap-4">
                                  <div>
                                    <p className="text-sm font-medium mt-2">
                                      Transfer Limit
                                    </p>
                                  </div>
                                  <div className="hidden md:block">
                                    <div>
                                      <p className="mt-2 flex items-center text-sm text-gray-500">
                                        {FormatMoney(set.dailyIndividualLimit)}{" "}
                                        {set.customerLimitApprovalStatus ===
                                          "Initiated" && (
                                          <>
                                            <p className="text-xs ml-1 text-orange-600">
                                              {" "}
                                              (Pending)
                                            </p>{" "}
                                          </>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <div>
                                    <p className="text-sm font-medium mt-2 flex">
                                      {FormatMoney(set.availableIndividuaLimit)}{" "}
                                      {set.lockAmount === true && (
                                        <>
                                          <HiIcons.HiLockClosed className="w-6 h-4 text-base" />
                                        </>
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <p
                                  className="text-sm font-medium mt-2 flex"
                                  style={{ marginRight: "-1rem" }}
                                >
                                  {FormatMoney(
                                    set.individualLimitPerTransaction
                                  )}{" "}
                                  {set.lockAmount === true && (
                                    <>
                                      <HiIcons.HiLockClosed className="w-6 h-4 text-base" />
                                    </>
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div></div>
                      </div>
                    </div>

                    {/* cooperate */}
                    <div className="col-span-4 mt-10">
                      <p className="underline mb-3">Corporate</p>
                      <div className="flex justify-between mb-3">
                        <p className="text-xs mr-4">Transaction Type</p>
                        <p className="text-xs ml-4">Daily Limit</p>
                        <p className="text-xs">Available Transaction Limit</p>
                        <p className="text-xs">Limit Per Transaction</p>
                      </div>
                      <div className="bg-white shadow overflow-hidden sm:rounded-md">
                        <div role="list" className="divide-y divide-gray-200">
                          <div>
                            <div className="block hover:bg-gray-50">
                              <div className="flex items-center px-4 py-4 sm:px-6">
                                <div className="min-w-0 flex-1 flex items-center">
                                  <div className="min-w-0 flex-1  md:grid md:grid-cols-3 md:gap-4">
                                    <div>
                                      <p className="text-sm font-medium mt-2">
                                        Airtime
                                      </p>
                                    </div>
                                    <div className="hidden md:block">
                                      <div>
                                        <p className="mt-2 flex items-center text-sm text-gray-500">
                                          {FormatMoney(set.dailyAirtimeLimit)}
                                        </p>
                                      </div>
                                    </div>
                                    <div>
                                      <p className="text-sm font-medium mt-2">
                                        {FormatMoney(set.availableAirtimeLimit)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <p className="text-sm font-medium mt-2">
                                    {FormatMoney(set.dailyAirtimeLimit)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="block hover:bg-gray-50">
                              <div className="flex items-center px-4 py-4 sm:px-6">
                                <div className="min-w-0 flex-1 flex items-center">
                                  <div className="min-w-0 flex-1  md:grid md:grid-cols-3 md:gap-4">
                                    <div>
                                      <p className="text-sm font-medium mt-2">
                                        Bill Payment
                                      </p>
                                    </div>
                                    <div className="hidden md:block">
                                      <div>
                                        <p className="mt-2 flex items-center text-sm text-gray-500">
                                          {FormatMoney(set.dailyBillLimit)}
                                        </p>
                                      </div>
                                    </div>
                                    <div>
                                      <p className="text-sm font-medium mt-2">
                                        {FormatMoney(set.availableBillLimit)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <p className="text-sm font-medium mt-2">
                                    {FormatMoney(set.dailyBillLimit)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="block hover:bg-gray-50">
                              <div className="flex items-center px-4 py-4 sm:px-6">
                                <div className="min-w-0 flex-1 flex items-center">
                                  <div className="min-w-0 flex-1  md:grid md:grid-cols-3 md:gap-4">
                                    <div>
                                      <p className="text-sm font-medium mt-2">
                                        Transfer Limit
                                      </p>
                                    </div>
                                    <div className="hidden md:block">
                                      <div>
                                        <p className="mt-2 flex items-center text-sm text-gray-500">
                                          {FormatMoney(set.dailyCorporateLimit)}
                                          {set.customerLimitApprovalStatus ===
                                            "Initiated" && (
                                            <>
                                              <p className="text-xs ml-1 text-orange-600">
                                                (Pending)
                                              </p>
                                            </>
                                          )}
                                        </p>
                                      </div>
                                    </div>

                                    <div>
                                      <p className="text-sm font-medium mt-2 flex">
                                        {FormatMoney(
                                          set.availableCorporateLimit
                                        )}{" "}
                                        {set.lockAmount === true && (
                                          <>
                                            <HiIcons.HiLockClosed className="w-6 h-4 text-base" />
                                          </>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <p className="text-sm font-medium mt-2 flex">
                                    {FormatMoney(
                                      set.corporateLimitPerTransaction
                                    )}{" "}
                                    {set.lockAmount === true && (
                                      <>
                                        <HiIcons.HiLockClosed className="w-6 h-4 text-base" />
                                      </>
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div></div>
                        </div>
                      </div>

                      <div className="mt-4 flex justify-end gap-2">
                        {/* Exceptional limit */}
                        <div className=" min-w-[10rem] flex justify-end">
                          {adminType.toLowerCase() === "maker" &&
                          set.exceptionalLimitDetails?.adminApprovalStatus?.toLowerCase() ===
                            "initiated" ? (
                            <div className="mt-3">
                              <i>Exceptional limit already initiated</i>
                            </div>
                          ) : (
                            <>
                              {(adminType.toLowerCase() === "maker" ||
                                (adminType.toLowerCase() === "checker" &&
                                  set.exceptionalLimitDetails &&
                                  set.exceptionalLimitDetails.adminApprovalStatus?.toLowerCase() ===
                                    "initiated")) && (
                                <button
                                  onClick={() => showException(set)}
                                  className="block py-3 px-5 text-sm bg-red-600 text-white text-left rounded-md"
                                  type="button"
                                >
                                  {set.exceptionalLimitDetails &&
                                  adminType.toLowerCase() === "maker" &&
                                  set.exceptionalLimitDetails
                                    ? "Update Exceptional Limit"
                                    : adminType.toLowerCase() !== "checker"
                                    ? "Add Exceptional Limit"
                                    : ""}
                                  {set.exceptionalLimitDetails &&
                                    adminType.toLowerCase() === "checker" &&
                                    set.exceptionalLimitDetails?.adminApprovalStatus?.toLowerCase() ===
                                      "initiated" &&
                                    "View Exceptional Limit"}
                                </button>
                              )}
                            </>
                          )}
                          {adminType.toLowerCase() === "checker" &&
                          set.exceptionalLimitDetails?.adminApprovalStatus?.toLowerCase() ===
                            "initiated" ? (
                            <>
                              <button
                                onClick={() => showReject()}
                                className="block py-3 ml-5 px-5 text-sm bg-black text-white text-left rounded-md"
                                type="button"
                              >
                                Reject Limit
                              </button>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        {/* Initiated limit */}
                        <div className=" min-w-[10rem] flex justify-end">
                          {adminType.toLowerCase() === "maker" ||
                          (adminType.toLowerCase() === "checker" &&
                            set.customerLimitApprovalStatus.toLowerCase() ===
                              "initiated") ? (
                            <button
                              onClick={() => showModal(set)}
                              className="block py-3 px-5 text-sm bg-red-600 text-white text-left rounded-md"
                              type="button"
                            >
                              {adminType.toLowerCase() === "checker"
                                ? "Approve Limit"
                                : "Initiate Limit"}
                            </button>
                          ) : (
                            <></>
                          )}
                          {adminType.toLowerCase() === "checker" &&
                          set.customerLimitApprovalStatus === "Initiated" ? (
                            <>
                              <button
                                onClick={() => showReject()}
                                className="block py-3 ml-5 px-5 text-sm bg-black text-white text-left rounded-md"
                                type="button"
                              >
                                Reject Limit
                              </button>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        {/* Initiate Default limit */}
                        <div className=" min-w-[10rem] flex justify-end">
                          {adminType.toLowerCase() === "maker" &&
                          set.setDefaultLimitApprovalStatus === "Initiated" ? (
                            <div className="mt-3">
                              <p>Default limit already initiated</p>
                            </div>
                          ) : (
                            <>
                              {(adminType.toLowerCase() === "maker" ||
                                (adminType.toLowerCase() === "checker" &&
                                  set.setDefaultLimitApprovalStatus?.toLowerCase() ===
                                    "initiated")) && (
                                <button
                                  onClick={() => showDefaultLimit(set)}
                                  className="block py-3 px-5 text-sm bg-red-600 text-white text-left rounded-md"
                                  type="button"
                                >
                                  {adminType.toLowerCase() === "checker"
                                    ? "Approve Default Limit"
                                    : "Initiate Default Limit"}
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </main>
  );

  return (
    <>
      {idProp ? (
        content
      ) : (
        <Layout pageTag={"customer"} current={"/customers"}>
          {content}
        </Layout>
      )}

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={handleClose}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xl sm:w-full sm:p-6">
                  <div>
                    <div className="mt-3 text-center sm:mt-5">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Hey, wait!!
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Are you sure you want to update customer limit?
                        </p>
                        <form>
                          <label
                            htmlFor="limitAmount"
                            className="text-left mt-2 block text-sm font-medium text-gray-700"
                          >
                            Limit Amount
                          </label>
                          <div className="mt-1">
                            <input
                              id="limitAmount"
                              name="limitAmount"
                              type="text"
                              placeholder="Enter limit amount"
                              value={formValue.limitAmount}
                              onChange={(e) => {
                                validation.amountHandler(e);
                              }}
                              required
                              className={`appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
                                adminType.toLowerCase() === "checker"
                                  ? "bg-gray-200 cursor-not-allowed"
                                  : ""
                              }`}
                              disabled={adminType.toLowerCase() === "checker"}
                            />
                            {!formState.lockAmountIsValidated &&
                              formState.lockAmountError && (
                                <div className="text-red-800">
                                  {formState.lockAmountError}
                                </div>
                              )}
                          </div>
                          <label
                            htmlFor="lockAmount"
                            className="text-left mt-2 block text-sm font-medium text-gray-700"
                          >
                            Lock amount?
                          </label>
                          <div className="mt-1">
                            <select
                              className={`focus:ring-indigo-500 focus:border-indigo-500 py-4 w-full border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md ${
                                adminType.toLowerCase() === "checker"
                                  ? "bg-gray-200 cursor-not-allowed"
                                  : ""
                              }`}
                              value={
                                adminType.toLowerCase() === "maker"
                                  ? formValue.lockAmount
                                  : set.lockAmount
                              }
                              onChange={validation.lockHandler}
                              disabled={adminType.toLowerCase() === "checker"}
                            >
                              <option value={true} defaultValue={true}>
                                Yes
                              </option>
                              <option value={false}>No</option>
                            </select>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                    {loading.loading === false ? (
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                        onClick={() => approve()}
                      >
                        Yes, I do
                      </button>
                    ) : (
                      <HollowDotsSpinner size={20} color="#4D627E" />
                    )}
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                      onClick={() => handleClose()}
                      ref={cancelButtonRef}
                    >
                      No, I don't
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={reject} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={handleRejectClose}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xl sm:w-full sm:p-6">
                  <div>
                    <div className="mt-3 text-center sm:mt-5">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Hey, wait!!
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Are you sure you want to reject customer limit?
                        </p>
                        <form>
                          <label
                            htmlFor="limitAmount"
                            className="text-left mt-2 block text-sm font-medium text-gray-700"
                          >
                            Limit Amount
                          </label>
                          <div className="mt-1">
                            <input
                              id="limitAmount"
                              name="limitAmount"
                              type="text"
                              placeholder="Enter limit amount"
                              value={FormatMoneyWithoutCurrency(
                                set.limitAmount
                              )}
                              className={`appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
                                adminType.toLowerCase() === "checker"
                                  ? "bg-gray-200 cursor-not-allowed"
                                  : ""
                              }`}
                              disabled={adminType.toLowerCase() === "checker"}
                            />
                          </div>
                          <label
                            htmlFor="lockAmount"
                            className="text-left mt-2 block text-sm font-medium text-gray-700"
                          >
                            Lock amount?
                          </label>
                          <div className="mt-1">
                            <select
                              className={`focus:ring-indigo-500 focus:border-indigo-500 py-4 w-full border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md ${
                                adminType.toLowerCase() === "checker"
                                  ? "bg-gray-200 cursor-not-allowed"
                                  : ""
                              }`}
                              value={set.lockAmount}
                              onChange={validation.lockHandler}
                              disabled={adminType.toLowerCase() === "checker"}
                            >
                              <option value={set.lockAmount}>
                                {set.lockAmount === false ? "No" : "Yes"}
                              </option>
                            </select>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                    {rejectLoading.loading === false ? (
                      <>
                        <button
                          type="button"
                          className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                          onClick={() => rejectLimit(set.userName)}
                        >
                          Yes, I do
                        </button>
                      </>
                    ) : (
                      <HollowDotsSpinner size={20} color="#4D627E" />
                    )}

                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                      onClick={() => handleRejectClose()}
                      ref={cancelButtonRef}
                    >
                      No, I don't
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* exceptional limit settings */}
      <Transition.Root show={openException} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={handleExceptionClose}
          static
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full min-w-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xl sm:w-full sm:p-6">
                  <div>
                    <button
                      className="text-gray-500 hover:text-gray-700 "
                      onClick={handleExceptionClose}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                    <div className="mt-3 text-center sm:mt-5">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Hey, wait!!
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Are you sure you want to
                          {set.exceptionalLimitDetails ? " update " : " add "}
                          exceptional limit?
                        </p>
                        <form>
                          <div>
                            <label
                              htmlFor="dailyIndividualLimit"
                              className="text-left mt-2 block text-sm font-medium text-gray-700"
                            >
                              Daily Individual Limit
                            </label>
                            <div className="mt-1">
                              <input
                                id="dailyIndividualLimit"
                                name="dailyIndividualLimit"
                                type="text"
                                placeholder="Enter daily individual limit amount"
                                value={exceptionFormValue.dailyIndividualLimit}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  exceptionValidation.exceptionAmountHandler(e);
                                }}
                                className={`appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
                                  adminType.toLowerCase() === "checker"
                                    ? "bg-gray-200 cursor-not-allowed"
                                    : ""
                                }`}
                                disabled={adminType.toLowerCase() === "checker"}
                              />
                            </div>
                          </div>
                          <div>
                            <label
                              htmlFor="individualLimitPerTransaction"
                              className="text-left mt-2 block text-sm font-medium text-gray-700"
                            >
                              Individual Limit Per Transaction
                            </label>
                            <div className="mt-1">
                              <input
                                id="individualLimitPerTransaction"
                                name="individualLimitPerTransaction"
                                type="text"
                                placeholder="Enter daily individual limit per transaction amount"
                                value={
                                  exceptionFormValue.individualLimitPerTransaction
                                }
                                onChange={(e) => {
                                  e.stopPropagation();
                                  exceptionValidation.exceptionAmountHandler(e);
                                }}
                                className={`appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
                                  adminType.toLowerCase() === "checker"
                                    ? "bg-gray-200 cursor-not-allowed"
                                    : ""
                                }`}
                                disabled={adminType.toLowerCase() === "checker"}
                              />
                            </div>
                          </div>
                          <div>
                            <label
                              htmlFor="dailyCorporateLimit"
                              className="text-left mt-2 block text-sm font-medium text-gray-700"
                            >
                              Daily Corporate Limit
                            </label>
                            <div className="mt-1">
                              <input
                                id="dailyCorporateLimit"
                                name="dailyCorporateLimit"
                                type="text"
                                placeholder="Enter daily corporate limit amount"
                                value={exceptionFormValue.dailyCorporateLimit}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  exceptionValidation.exceptionAmountHandler(e);
                                }}
                                className={`appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
                                  adminType.toLowerCase() === "checker"
                                    ? "bg-gray-200 cursor-not-allowed"
                                    : ""
                                }`}
                                disabled={adminType.toLowerCase() === "checker"}
                              />
                            </div>
                          </div>
                          <div>
                            <label
                              htmlFor="corporateLimitPerTransaction"
                              className="text-left mt-2 block text-sm font-medium text-gray-700"
                            >
                              Corporate Limit Per Transaction
                            </label>
                            <div className="mt-1">
                              <input
                                id="corporateLimitPerTransaction"
                                name="corporateLimitPerTransaction"
                                type="text"
                                placeholder="Enter daily corporate limit per transaction amount"
                                value={
                                  exceptionFormValue.corporateLimitPerTransaction
                                }
                                onChange={(e) => {
                                  e.stopPropagation();
                                  exceptionValidation.exceptionAmountHandler(e);
                                }}
                                className={`appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
                                  adminType.toLowerCase() === "checker"
                                    ? "bg-gray-200 cursor-not-allowed"
                                    : ""
                                }`}
                                disabled={adminType.toLowerCase() === "checker"}
                              />
                            </div>
                          </div>

                          <div>
                            <label
                              htmlFor="inputFile"
                              className="text-left mt-2 block text-sm font-medium text-gray-700"
                            >
                              {adminType.toLowerCase() === "maker"
                                ? "Upload "
                                : "Download "}
                              Exceptional Limit Document
                            </label>
                            <div className="mt-2">
                              {adminType.toLowerCase() === "maker" ? (
                                <>
                                  {exceptionFormValue.concessionDocumentLink && (
                                    <input
                                      id="inputFile"
                                      name="inputFile"
                                      type="file"
                                      placeholder="Upload File"
                                      disabled={
                                        adminType.toLowerCase() === "checker"
                                      }
                                      onChange={
                                        exceptionValidation.handleFileInputChange
                                      }
                                      required
                                      multiple
                                      className={`appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
                                        adminType.toLowerCase() === "checker"
                                          ? "bg-gray-200 cursor-not-allowed"
                                          : ""
                                      }`}
                                    />
                                  )}
                                </>
                              ) : (
                                <>
                                  <div>
                                    {exceptionFormValue.concessionDocumentLink.map(
                                      (file, index) => (
                                        <div key={index}>
                                          <a
                                            href={`${file}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-indigo-500 hover:text-indigo-700"
                                            download
                                          >
                                            {getName(file)}
                                          </a>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </>
                              )}
                              {!formState.lockAmountIsValidated &&
                                formState.lockAmountError && (
                                  <div className="text-red-800">
                                    {formState.lockAmountError}
                                  </div>
                                )}
                            </div>
                          </div>

                          {adminType.toLowerCase() === "checker" && (
                            <div>
                              <label
                                htmlFor="concessionRejectionReason"
                                className="text-left mt-2 block text-sm font-medium text-gray-700"
                              >
                                Comment
                              </label>
                              <div className="mt-1">
                                <textarea
                                  id="concessionRejectionReason"
                                  name="concessionRejectionReason"
                                  rows={3}
                                  placeholder="Enter your comment here"
                                  value={concessionRejectionReason}
                                  onChange={handleCommentChange}
                                  className="appearance-none block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                                {commentError && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {commentError}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                    {adminType.toLowerCase() === "checker" ? (
                      <>
                        {loading.loading === false ? (
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-3 bg-white hover:bg-gray-900 hover:text-white text-base font-medium text-gray-900 sm:text-sm"
                            onClick={() =>
                              exception(
                                exceptionFormValue.dailyIndividualLimit,
                                exceptionFormValue.dailyCorporateLimit,
                                exceptionFormValue.individualLimitPerTransaction,
                                exceptionFormValue.corporateLimitPerTransaction
                              )
                            }
                          >
                            Approve
                          </button>
                        ) : (
                          <HollowDotsSpinner size={20} color="#4D627E" />
                        )}
                        {rejectLoading.loading === false ? (
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-3 bg-red-600 hover:bg-gray-900 hover:text-white text-base font-medium text-white sm:text-sm"
                            onClick={() => rejectException()}
                          >
                            Reject
                          </button>
                        ) : (
                          <HollowDotsSpinner size={20} color="#4D627E" />
                        )}
                      </>
                    ) : (
                      <>
                        {loading.loading === false ? (
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white hover:bg-gray-900 hover:text-white text-base font-medium text-gray-900 sm:col-start-2 sm:text-sm"
                            onClick={() =>
                              exception(
                                exceptionFormValue.dailyIndividualLimit,
                                exceptionFormValue.dailyCorporateLimit,
                                exceptionFormValue.individualLimitPerTransaction,
                                exceptionFormValue.corporateLimitPerTransaction
                              )
                            }
                          >
                            Upload
                          </button>
                        ) : (
                          <HollowDotsSpinner size={20} color="#4D627E" />
                        )}
                      </>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Default limit settings */}
      <Transition.Root show={openDefault} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={handleDefaultClose}
          static
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full min-w-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xl sm:w-full sm:p-6">
                  <div>
                    <button
                      className="text-gray-500 hover:text-gray-700 "
                      onClick={handleDefaultClose}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                    <div className="mt-3 text-center sm:mt-5">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Hey, wait!!
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          {adminType.toLowerCase() === "maker"
                            ? "Are you sure you want to initiate default limit?"
                            : "Are you sure you want to approve the default limit?"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                    {adminType.toLowerCase() === "checker" ? (
                      <>
                        <button
                          type="button"
                          className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-3 bg-white hover:bg-gray-900 hover:text-white text-base font-medium text-gray-900 sm:text-sm"
                          onClick={setDefaultLimit}
                        >
                          Approve
                        </button>
                        <button
                          type="button"
                          className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-3 bg-red-600 hover:bg-gray-900 hover:text-white text-base font-medium text-white sm:text-sm"
                          onClick={declineDefaultLimit}
                        >
                          Reject
                        </button>
                      </>
                    ) : (
                      <>
                        {loading ? (
                          <div className="flex items-center justify-center gap-3 w-full">
                            <button
                              type="button"
                              className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white hover:bg-gray-900 hover:text-white text-base font-medium text-gray-900 sm:col-start-2 sm:text-sm"
                              onClick={setDefaultLimit}
                            >
                              Yes I do
                            </button>
                            <button
                              type="button"
                              className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-3 bg-red-600 hover:bg-gray-900 hover:text-white text-base font-medium text-white sm:text-sm"
                              onClick={handleDefaultClose}
                            >
                              No I don't
                            </button>
                          </div>
                        ) : (
                          <HollowDotsSpinner size={20} color="#4D627E" />
                        )}
                      </>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
